import React from 'react';
import {TableCell} from '@material-ui/core';
import classnames from 'classnames';
import {cellAlignment, isExpandingCell} from './helpers';
import {ListTableColumn} from './tableTypes';

export interface HeaderCellProps {
    column: ListTableColumn;
    rowHeight: number;
}

const HeaderCell = ({column, rowHeight}: HeaderCellProps) => {
    const alignment = cellAlignment(column.numeric);
    const classes = classnames('cell', {
        expandingCell: isExpandingCell(column.width),
    });
    const styles = {
        flexBasis: column.width,
        height: rowHeight,
    };
    return (
        <TableCell
            component="div"
            title={column.label}
            variant="head"
            align={alignment}
            className={classes}
            style={styles}
            scope="col"
        >
            {column.label}
        </TableCell>
    );
};

export default HeaderCell;
